module.exports = __webpack_public_path__ + "img/AIMS2GOlogo.9ecb95ec.png";